<template>
  <vs-row>
    <vs-col>
      <div v-if="successLoadGraph" class="dashboard-layout-auto">
        <donut-chart01 dataType="project" size="large" :reload-count="reloadCount" orientation="landscape"/>
        <donut-chart02 dataType="project" size="large" :reload-count="reloadCount" orientation="landscape"/>
        <donut-chart21 dataType="project" size="large" :reload-count="reloadCount" orientation="landscape"/>
        <donut-chart06 dataType="project" size="large" :reload-count="reloadCount" orientation="landscape"/>
        <donut-chart09 dataType="project" size="large" :reload-count="reloadCount" orientation="landscape"/>
        <donut-chart16 dataType="project" size="large" :reload-count="reloadCount" orientation="landscape"/>
      </div>
    </vs-col>
  </vs-row>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'
import HomeNotificationCard from '@/components/HomeNotificationCard'
import CommunityHealthinfoCard from '@/components/CommunityHealthinfoCard'
import CommunityWorkNewsCard from '@/components/CommunityWorkNewsCard'
import CommunityBusinessNewsCard from '@/components/CommunityBusinessNewsCard'
import DonutChart01 from '@/views/graph/DonutChart01'
import DonutChart02 from '@/views/graph/DonutChart02'
import DonutChart06 from '@/views/graph/DonutChart06'
import DonutChart09 from '@/views/graph/DonutChart09'
import DonutChart16 from '@/views/graph/DonutChart16'
import DonutChart21 from '@/views/graph/DonutChart21.vue'

export default {
  components: {
    DonutChart21,
    DonutChart16,
    DonutChart09,
    DonutChart06,
    DonutChart02,
    DonutChart01,
    CommunityBusinessNewsCard,
    CommunityWorkNewsCard,
    CommunityHealthinfoCard,
    HomeNotificationCard,
    DonutChartCard
  },
  data () {
    return {
      successLoadGraph: false,
      reloadCount: 0,
      timerId: undefined,
    }
  },
  computed:{
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    username () {
      return this.myInfo ? this.myInfo.username : ''
    },
    hasDashboardCharts () {
      const memberInfo = this.$store.state.member.memberInfo;
      const hasDashboardCharts = memberInfo.has_dashboard_charts
      if (hasDashboardCharts) {
        const list = []
        for (const chart of hasDashboardCharts) {
          if (chart.visible && chart.project_id === 0) {
            const code = chart.dashboard_chart.code
            list.push(code)
          }
        }
        return list
      }

      return undefined
    }
  },
  async created () {
    const location = window.location
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL").then(value => {
      this.successLoadGraph = true
      if (value.username !== 'ep6000!') {
        location.href = '/'
      }
    });
  },
  mounted () {
    this.timerId = setTimeout(this.countDown, 1000 * 60 * 10); // (*)
  },
  methods: {
    countDown () {
      this.reloadCount++
      if (this.reloadCount > 10000) {
        this.reloadCount = 0
      }
      this.timerId = setTimeout(this.countDown, 1000 * 60 * 10); // (*)
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-layout-auto {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3.75rem;
  padding: 3.75rem;

  grid-template-columns: 1fr 1fr 1fr ;
  font-size: 3.0rem;

  background-color: #202124;
}
</style>

<style lang="scss">
html, body {
  background-color: #202124;
}

.vx-card {
  background-color: #323639;
  color: #eee;
}

.dashboard-layout-auto {

  .dot {
    width: 1.125rem;
    height: 1.125rem;
    background-color: #7E72F2;

    display: inline-flex;
    border-radius: 50%;

    margin-right: 1.125rem;
  }
  .total-value {
    color: #EEEEEE !important;
  }
  .total-unit {
    color: #C0C0C0 !important;
  }
  .datas {
    height: 380px !important;
  }
  .donut {
    margin-top: 3.5rem !important; margin-bottom: 3.5rem !important;
  }
}
</style>
